module.exports = __webpack_public_path__ + "static/img/QLD-28.2107634.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/QLD-28.jpg
// module id = sYC9
// module chunks = 0